
import React, {useContext, useEffect, useState} from "react";
import {Dialog, DialogContent, Divider, Grid} from "@mui/material";
import CoOwnersDetailDialogForm from "./CoOwnersDetailDialogForm";
import SuretiesDetailDialogForm from "../components-sureties-data/SuretiesDetailDialogForm";
import {
    Client,
    ClientFields,
    ClientForm,
    CoOwnerRelationshipWithoutSolicitation
} from "../../../../../types/client/clientData";
import {HttpClient} from "../../../../../http/client/httpClient";
import {EntityWithIdFields} from "../../../../../types/baseEntities";
import {SolicitationClient, SolicitationClientFields} from "../../../../../types/solicitation/solicitationData";
import {CompanyContext} from "../../../context/companyContext";
import CompanyCuitSyncDialogContent
    from "../../../../../@core/layouts/components/horizontal/app-bar-content/CompanyCuitSyncDialogContent";
import BaseDialogTitle from "../../../../../components/dialog/BaseDialogTitle";

interface DialogNewCoOwnerProps {
    open: boolean,
    onClose: () => void,
    prevCoOwner?: SolicitationClient
    setCoOwners?: (list: CoOwnerRelationshipWithoutSolicitation[]) => void,
    prevCoOwnerFront?: CoOwnerRelationshipWithoutSolicitation,
    coOwnersFront?: CoOwnerRelationshipWithoutSolicitation[],
    onFinishBackSave?: () => void,
    withoutSolicitation?: boolean
}


const DialogNewCoOwner = ({open, onClose, prevCoOwner, setCoOwners, prevCoOwnerFront, coOwnersFront, onFinishBackSave, withoutSolicitation}: DialogNewCoOwnerProps) => {
    const [cuitValidate, setCuitValidate] = useState<boolean>(false)
    const [client, setClient] = useState<Client>()
    const {clientSolicitationId} = useContext(CompanyContext)
    
    const onFinishFrontSave = (coOwner: CoOwnerRelationshipWithoutSolicitation) => {
        if(withoutSolicitation && !prevCoOwnerFront && coOwnersFront){
            const coOwnerAdd = {
                ...coOwner,
                [EntityWithIdFields.Id]: coOwnersFront.length + 1
            }
            const coOwnersList: CoOwnerRelationshipWithoutSolicitation[] = [...coOwnersFront, coOwnerAdd]
            setCoOwners && setCoOwners(coOwnersList)
            
        }
        if(withoutSolicitation && prevCoOwnerFront && coOwnersFront) {
            const newList = coOwnersFront.map((x) => {
                if (x[EntityWithIdFields.Id] === coOwner[EntityWithIdFields.Id]) {
                    return coOwner
                }
                
                return x
            })
            setCoOwners && setCoOwners(newList);
        }
        
        const clientUpdate = {
            ...client,
            [ClientFields.AfipResponsibilityTypeCode]: coOwner[ClientFields.AfipResponsibilityTypeCode],
            [ClientFields.MaritalStatusCode]: coOwner[ClientFields.MaritalStatusCode],
            [ClientFields.ClientClassificationCode]: coOwner[ClientFields.ClientClassificationCode]
        }
        
        HttpClient.update(clientUpdate as unknown as ClientForm).finally(() => {
            onClose()
            setCuitValidate(false)
            setClient(undefined)
        })
    }

    useEffect(() => {
        if(prevCoOwner && !client) {
            setCuitValidate(true)
            HttpClient.getById(prevCoOwner[SolicitationClientFields.ClientId]).then((r) => {
                setClient(r)
            })
        }
    }, [prevCoOwner])

    useEffect(() => {
        if(prevCoOwnerFront && !client) {
            setCuitValidate(true)
            HttpClient.getById(prevCoOwnerFront[ClientFields.Id]).then((r) => {
                setClient(r)
            })
        }
    }, [prevCoOwnerFront])
    
    return (
        <Dialog open={open} onClose={() => {
            onClose()
            setCuitValidate(false)
            setClient(undefined)
        }} maxWidth={'md'} fullWidth>
            <BaseDialogTitle title={(prevCoOwner || prevCoOwnerFront) ? 'Editar cotitular' : 'Nuevo cotitular'}
                             onClose={() => {
                                 onClose()
                                 setCuitValidate(false)
                                 setClient(undefined)
                             }}
            />
            <Divider />
            <DialogContent>
                {
                    (!cuitValidate) ?
                        <>
                            {
                                !prevCoOwner && !client && !prevCoOwnerFront &&
                                <CompanyCuitSyncDialogContent subtitle={'Ingrese un CUIT para sincronizar los datos con AFIP y agilizar la operación'}
                                                              onSave={(client: Client) => {
                                                                  setCuitValidate(true)
                                                                  setClient(client)
                                                              }}
                                />
                            }
                        </>
                        :
                        <Grid container justifyContent={'center'} spacing={4}>
                            {
                                !!client && withoutSolicitation &&
                                <CoOwnersDetailDialogForm client={client}
                                                          onFinishSave={onFinishFrontSave}
                                                          onBack={() => {
                                                              onClose()
                                                              setCuitValidate(false)
                                                              setClient(undefined)
                                                          }}
                                                          setCoOwners={setCoOwners}
                                                          coOwnerToEdit={prevCoOwnerFront}
                                />
                            }
                            {
                                !!client && !withoutSolicitation &&
                                <SuretiesDetailDialogForm client={client}
                                                          onFinishSave={() => {
                                                              onFinishBackSave && onFinishBackSave()
                                                              onClose()
                                                              setCuitValidate(false)
                                                              setClient(undefined)
                                                          }}
                                                          onBack={() => {
                                                              onClose()
                                                              setCuitValidate(false)
                                                              setClient(undefined)
                                                          }}
                                                          solicitationId={clientSolicitationId}
                                                          clientToEdit={prevCoOwner}
                                                          coOwners
                                />
                            }
                        </Grid>
                }
            </DialogContent>
        </Dialog>
    )
}


export default DialogNewCoOwner